// extracted by mini-css-extract-plugin
export default {"emptyTarget":"notifications_emptyTarget__Hdhlo","notificationsWrapper":"notifications_notificationsWrapper__3ss6G"};